import type { ActivityModality, ActivityType } from '/@/hooks/activities';
import type { UserNode } from '/@/hooks/nodes';
import { _ } from '/@/locale';

export const ACTIVITY_TYPE_OPTIONS: { value: ActivityType; label: string }[] = [
    { value: 'entrenamiento', label: _('Entrenamiento') },
    { value: 'generacion_demanda', label: _('Generación de demanda') },
];

export const MODALITY_OPTIONS: { value: ActivityModality; label: string }[] = [
    { value: 'presencial', label: _('Presencial') },
    { value: 'virtual', label: _('Virtual') },
];

export const getActivityTypeLabel = (value: ActivityType) =>
    ACTIVITY_TYPE_OPTIONS.find((option) => option.value === value)?.label ?? value;

export const getModalityLabel = (value: ActivityModality) =>
    MODALITY_OPTIONS.find((option) => option.value === value)?.label ?? value;

export const ROLE_LABELS: Record<UserNode['type'], string> = {
    rv: 'RV',
    advisor: _('Asesor'),
    consultant: _('Consultor'),
    grower: _('Productor'),
    squad: 'Squad',
    squad_coach: _('Squad Coach'),
    other: _('Otro'),
};

export const getInitials = (name: string) =>
    name
        .split(' ')
        .filter(Boolean)
        .slice(0, 2)
        .map((part) => part[0]?.toUpperCase())
        .join('');
